const url = '/passports';
const Provider = 'Passports';
const dbModel = 'Passports';

export { url, Provider, dbModel };
